import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CarProvidersAuthService } from '@csProviders/services/auth/auth.service';
import { CustomFiltersService } from '@team/services/common/custom-filters.service';
import { FormResetService } from '@team/services/form-reset.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'providers-menu',
  standalone: false,
  templateUrl: './providers-menu.component.html',
  styleUrls: ['./providers-menu.component.scss']

})
export class ProvidersMenuComponent implements OnInit {
  menuLinks;
  showMenu = false;
  @Input() isFullWidth;
  collapseMenu: boolean;
  openMenu: boolean = false;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private frs: FormResetService,
    private common: CustomFiltersService,
    private auth: CarProvidersAuthService
  ) { }

  ngOnInit() {
    this.buildMenu();
    if (localStorage.getItem('collapsed') === null) {
      this.collapseMenu = true;
    } else {
      this.collapseMenu = JSON.parse(localStorage.getItem('collapsed'));
      this.common.collapseMenu(this.collapseMenu);
    }
    this.frs.changeStats.subscribe(() => { });
    this.buildMenu();
  }
  buildMenu() {
    this.menuLinks = [
      {
        title: 'الطلبات',
        link: '/home/requests/list',
        icon: 'banking-bill-overdue'
      },
      {
        title: 'تسجيل الخروج',
        link: '/login',
        icon: 'logout-1'
      }
    ];
  }
  logOut() {
    this.auth.logout();
    this.toastr.success('تم تسجيل الخروج');
    this.router.navigate(['/login/']);
  }

  toggleMenu() {
    this.openMenu = !this.openMenu;
  }

  toggleMenuResponsive() {
    this.showMenu = !this.showMenu;
  }
  toggleMenuDesktop() {
    this.collapseMenu = !this.collapseMenu;
    this.common.collapseMenu(this.collapseMenu);
    localStorage.setItem('collapsed', JSON.stringify(this.collapseMenu));
  }
  menuLinkClicked(e) {
    this.showMenu = false;
    if (e.target.innerText === 'تسجيل الخروج') {
      this.logOut();
    }
  }
}